import { NetworkError } from './NetworkError.js';

class TooManyRequestsError extends NetworkError {
    retryAfter;
    constructor(message = 'Too Many Requests', retryAfter) {
        super(message, 429);
        this.retryAfter = retryAfter;
    }
    toJSON() {
        const json = super.toJSON();
        return {
            ...json,
            ...(this.retryAfter ? { retryAfter: this.retryAfter } : {}),
        };
    }
}

export { TooManyRequestsError };
//# sourceMappingURL=TooManyRequestsError.js.map
